export { defaultConfig } from './default';

export { se } from './se';
export { no } from './no';
